import { render, staticRenderFns } from "./Banner1.vue?vue&type=template&id=6096b6e1&scoped=true&"
import script from "./Banner1.vue?vue&type=script&lang=js&"
export * from "./Banner1.vue?vue&type=script&lang=js&"
import style0 from "./Banner1.vue?vue&type=style&index=0&id=6096b6e1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096b6e1",
  null
  
)

export default component.exports